import Box from '@mui/material/Box';

import { IconTag } from '@/components/icon/tabler/IconTag';
import { radiusTokens } from '@/theme/themePrimitives';

interface Props {
  code: string;
}

/** The coupon as the app shows it: a dashed chip with the code, ready to copy. */
const OfferCouponCode = ({ code }: Props) => (
  <Box component="span" sx={sx.chip}>
    <IconTag sx={{ fontSize: 16 }} />
    {code}
  </Box>
);

export default OfferCouponCode;

const sx = {
  chip: {
    display: 'inline-flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
    gap: 0.75,
    px: 1.25,
    py: 0.5,
    border: '1.5px dashed',
    borderColor: 'text.secondary',
    borderRadius: radiusTokens.lg,
    typography: 'body2',
    fontFamily: 'monospace',
    fontWeight: 700,
    letterSpacing: '0.08em',
    maxWidth: '100%',
    overflowWrap: 'anywhere',
  },
};
